export default __webpack_public_path__ + "static/media/Rectangle 10.b9197540.png";